import { Component, OnInit, Inject, ViewChild, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { NgForm } from '@angular/forms';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PhoneAuthenticationService } from '../../_services/phone-authentication.service';
import { ScriptLoaderService } from '../../_services/script-loader.service';
import { UserService } from '../../_services/user.service';
import { ApiService } from '../../_services/api.service';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'app-phone-take-request',
  templateUrl: './phone-take-request.component.html',
  styleUrls: ['./phone-take-request.component.css']
})
export class PhoneTakeRequestComponent implements OnInit {

  @ViewChild('f') public form: NgForm;
  user: any;
  registerModel: any = { day: 'Gün', month: 'Ay', year: 'Yıl' };
  loading: boolean;
  isCodeSent: boolean;
  isInvalidPhoneNumber: boolean;
  isInvalidCode: boolean;
  lastUser;
  public mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  private subscription: Subscription = new Subscription();
  constructor(
    private http: Http,
    private zone: NgZone,
    private afs: AngularFirestore,
    public dialogRef: MatDialogRef<PhoneTakeRequestComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private scriptLoader: ScriptLoaderService,
    private router: Router,
    private userService: UserService,
    private apiService: ApiService,
    private phoneAuthService: PhoneAuthenticationService
  ) {

  }

  ngOnInit() {
  }
  save() {
    this.loading = true;
    if (!this.isCodeSent) {
      this.phoneAuthService.sendOtp(this.registerModel.phoneNumber)
        .then(res => {
          this.loading = false;
          this.isCodeSent = true;
          this.isInvalidPhoneNumber = false;
        }).catch(err => {
          this.isInvalidPhoneNumber = true;
          this.loading = false;
        });
      return;
    }
    if (!this.phoneAuthService.confirm(this.registerModel.code)) {
      this.isInvalidCode = true;
      this.loading = false;
      return;
    }
    this.isInvalidPhoneNumber = false;
    let update = {};
    const id = localStorage.getItem("currentUserId");


    this.subscription = this.userService.getUser().subscribe(elem => {
      this.lastUser = elem;
    });

    var users = {
      userKey: this.lastUser.id,
      agreement: this.lastUser.agreement || null,
      birthday: this.dateFormat(new Date(this.lastUser.birthday.year + "/" + this.lastUser.birthday.month + "/" + this.lastUser.birthday.day)),
      totalPoint: this.lastUser.point.totalPoint || null,
      username: this.lastUser.username,
      email: this.lastUser.email,
      firstname: this.lastUser.firstname,
      isEmailVerified: this.lastUser.isEmailVerified || null,
      isSecret: this.lastUser.isSecret || null,
      joinDate: this.dateFormat(new Date(this.lastUser.joinDate)),
      lastname: this.lastUser.lastname,
      level: this.lastUser.level,
      city: this.lastUser.city || null,
      phoneNumber: this.registerModel.phoneNumber || null,
      education: this.lastUser.education || null,
      gender: this.lastUser.gender || null,
      job: this.lastUser.job || null,
      profileImage: this.lastUser.profileImage || null,
      followings: this.lastUser.following ? this.lastUser.following.length : 0,
      followers: this.lastUser.followers ? this.lastUser.followers.length : 0
    }
    this.subscription = this.apiService.sqlPost('users/insertUpdateUser', users).map(res => res.json()).subscribe(a => a);
    this.afs.collection('users').doc(id).update({
      phoneNumber: this.registerModel.phoneNumber,
      isNewRegistered: false
    }).then(() => {
      this.dialogRef.close();
    });
  }
  public ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  dateFormat(data) {
    if (data.length == 10) {
      return data;
    }
    var dd = data.getDate();
    var mm = data.getMonth() + 1; //January is 0!
    var yyyy = data.getFullYear();

    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }

    data = yyyy + '-' + mm + '-' + dd;
    return data;
  }
}




// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/directive/phone-take-request/phone-take-request.component.ts